import React from "react";
import Back from "../common/Back";
import Heading from "../common/Heading";
import img from "../images/about.jpg";
import "./about.css";
import { useTranslation } from "react-i18next";

const About = () => {
  const { t } = useTranslation();
  return (
    <>
      <section className="about">
        <Back name={t("about")} title={t("about_title")} cover={img} />
        <div className="container mt-10">
          <div className="row">
            <div className="col-lg-6">
              <Heading
                title={t("featured_title")} //"Our Agency Story"
                subtitle={t("about_subtitle")} //"Check out our company story and work process"
              />

              <p>{t("about_para1")}. </p>
              <p>{t("about_para2")}</p>
              <button className="callbutton">
                <a
                  href="/contact"
                  style={{
                    color: "#ffffff",
                    textDecoration: "none",
                    marginLeft: "0px",
                    fontWeight: "400",
                  }}
                >
                  {t("contact_us")}&nbsp;{" "}
                  <span class="fa fa-arrow-right"></span>
                </a>
              </button>
            </div>
            <div className="col-lg-6">
              <img src="./images/about.jpg" alt="" />
            </div>
          </div>
          <br />
          <hr />
        </div>

        <br />
        <div class="container">
          <div class="col-lg-12 heading">
            <h1 class="center1">{t("vm_title")}</h1>
            <p style={{ textAlign: "center", fontFamily: "Poppins" }}>
              {t("vm_subtitle")}
            </p>
          </div>
        </div>
        <br />

        <div class="container recent">
          <div class="content grid3 mtop">
            <div class="box shadow1" style={{ marginBottom: "20px" }}>
              <div class="center3">
                <i className="fa fa-eye vision"></i>
              </div>
              <div>
                <div class="category flex"></div>
                <h4 class="listheaderv">{t("vision_title")}</h4>
                <ul className="liststyle text">
                  <li> {t("vision_point1")}</li>
                  <li> {t("vision_point2")} </li>
                  <li>{t("vision_point3")}</li>
                </ul>
              </div>
            </div>

            <div class="box shadow1" style={{ marginBottom: "20px" }}>
              <div class="center3">
                <i className="fa fa-bullseye  vision"></i>
              </div>
              <div>
                <div class="category flex"></div>
                <h4 class="listheaderv">{t("mission_title")}</h4>
                <ul className="liststyle text">
                  <li> {t("mission_point1")}</li>
                  <li>{t("mission_point2")}</li>
                  <li>{t("mission_point3")}</li>
                  <li>{t("mission_point4")}</li>
                </ul>
              </div>
            </div>

            <div class="box shadow1" style={{ marginBottom: "20px" }}>
              <div class="center3">
                <i className="fa fa-id-badge   vision"></i>
              </div>
              <div>
                <div class="category flex"></div>
                <h4 class="listheaderv">{t("value_title")}</h4>
                <ul className="liststyle text">
                  <li> {t("value_point1")}</li>
                  <li>{t("value_point2")}</li>
                  <li>{t("value_point3")}</li>
                  <li>{t("value_point4")}</li>
                  <li>{t("value_point5")}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="awards padding">
        <div className="container">
          <div className="heading">
            <h1>{t("awards_title")}</h1>
          </div>

          <div className="content grid4 mtop">
            {/* Box 1 */}
            <div className="box">
              <div className="icon">
                <span>
                  <i className="fa-solid fa-trophy"></i>
                </span>
              </div>
              <h1>{t("awards_exp_title")}</h1>
              <p>{t("awards_exp_desc")}</p>
            </div>

            {/* Box 2 */}
            <div className="box">
              <div className="icon">
                <span>
                  <i className="fa-solid fa-user"></i>
                </span>
              </div>
              <h1>{t("awards_customers_title")}</h1>
              <p>{t("awards_customers_desc")}</p>
            </div>

            {/* Box 3 */}
            <div className="box">
              <div className="icon">
                <span>
                  <i className="fa-solid fa-briefcase"></i>
                </span>
              </div>
              <h1>{t("awards_projects_title")}</h1>
              <p>{t("awards_projects_desc")}</p>
            </div>

            {/* Box 4 */}
            <div className="box">
              <div className="icon">
                <span>
                  <i className="fa-solid fa-heart"></i>
                </span>
              </div>
              <h1>{t("awards_reviews_title")}</h1>
              <p>{t("awards_reviews_desc")}</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
